module.exports = __webpack_public_path__ + "static/media/Standup-Sprint-4-Audio-2.9bc940d8.mp3";